/**
 * API Configuration
 *
 * ALWAYS uses relative URLs (empty string) which works for both:
 * - Development: Uses React's proxy in package.json
 * - Production: Backend and frontend served from same domain
 *
 * NO MORE ENVIRONMENT VARIABLES NEEDED!
 */

export const API_BASE_URL = '';

// WebSocket URL - for Socket.IO connections
export const getWebSocketURL = (): string => {
  if (typeof window === 'undefined') return '';

  // Check if REACT_APP_API_BASE_URL is set (for mobile development)
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  if (apiUrl && apiUrl.includes('http')) {
    return apiUrl;
  }

  // In development, React runs on :3000 but proxy doesn't work for WebSocket
  // So we need to explicitly connect to backend on :8080
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8080';
  }

  // In production, use same origin (both on same domain)
  return '';
};
